export enum ListViewIconSize {
  small = 1,
  medium = 2,
  large = 3,
}